import { Component, Input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { Track } from '../../models/interfaces/track.interface';
import { Router } from '@angular/router';
import { ButtonRadiusEnum } from '../button/types/button-radius.enum';

@Component({
  selector: 'l-track-card',
  imports: [ButtonComponent],
  templateUrl: './track-card.component.html',
})
export class TrackCardComponent {

  //#region Constructor

  constructor(
    private readonly router: Router
  ) {}

  //#endregion

  //#region Public Properties

  @Input({ required: true }) 
  public track!: Track;

  public buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  //#endregion

  //#region Public Methods

  public navigateToTrack(): void {
    this.router.navigate(['/tracks', this.track.id]);
  }

  //#endregion

}
